<div class="p-fluid">

  <div class="titulo monitoramento" (click)="mostrarDados = !mostrarDados">
    <i class="pi pi-pw" [ngClass]="{ 'pi-caret-right': !mostrarDados, 'pi-caret-down': mostrarDados}"></i>{{aplicacao.nome}}
    <span *ngIf="aplicacao.carregando">
      <em class="pi-pw pi pi-spin pi-spinner"></em>
    </span>
    <ng-container *ngIf="!aplicacao.carregando">
      <span *ngIf="aplicacao.isSituacaoFalha() || aplicacao.monitoramento === undefined">
        <em class="pi pi-pw pi-times-circle text-danger"></em>
      </span>
      <span *ngIf="aplicacao.isSituacaoSucesso() && aplicacao.monitoramento != undefined">
        <em class="pi-fw pi pi-check p-text-bold text-success"></em>
      </span>
    </ng-container>
  </div>

  <div class="conteudo" *ngIf="!aplicacao.carregando">

    <div class="ativos" *ngIf="aplicacao.monitoramento != undefined">
      <ng-container *ngFor="let ativo of aplicacao.ativos">
        <app-ativo-visualizador [ativo]="ativo" style="font-size: 18px;"></app-ativo-visualizador>
      </ng-container>
    </div>

    <div *ngIf="mostrarDados" style="margin-top: 1em">

      <div *ngIf="aplicacao.monitoramento === undefined">
        Não foi possível recuperar os dados de monitoramento.
      </div>

      <p-tabView *ngIf="aplicacao.monitoramento !== undefined">
        <p-tabPanel header="Dados">
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Nome:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.nome}}</div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Versão:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.versao}}</div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Ambiente:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.ambiente}}</div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Data de compilação:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.dataCompilacao}}</div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Commit SHA:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.commitSha}}</div>
          </div>

          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Pipeline ID:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.pipelineId}}</div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Sistema">
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Hostname:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.hostname}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Tipo:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.tipo}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Versão:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.versao}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Locale:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.locale.nome}} - {{aplicacao.monitoramento.aplicacao.sistema.locale.pais}}/{{aplicacao.monitoramento.aplicacao.sistema.locale.linguagem}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">TimeZone:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.timeZone.id}} - {{aplicacao.monitoramento.aplicacao.sistema.timeZone.nome}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Horário Local:</div>
            <div class="p-col-12 p-lg-10">
              {{aplicacao.monitoramento.aplicacao.sistema.timeZone.horarioLocal}}<br/>
              {{aplicacao.monitoramento.aplicacao.sistema.timeZone.horarioLocalPorExtenso}}
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Memória - Total:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.memoria.total}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Memória - Livre:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.memoria.livre}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Memória - Usada:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.memoria.usada}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Memória - Máxima:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.memoria.maxima}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Charset:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.charset}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-12 p-lg-2">Processadores:</div>
            <div class="p-col-12 p-lg-10">{{aplicacao.monitoramento.aplicacao.sistema.processadores}}</div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="Configurações">
          <pre>{{aplicacao.monitoramento.aplicacao.configuracoes | json}}</pre>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
